import vip_room_preview from './vip_room_preview.jpg'
import vip_room from './vip_room.jpg'

import image1 from './image1.jpg'
import image2 from './image2.jpg'
import image3 from './image3.jpg'

import thumb1 from './thumb1.jpg'
import thumb2 from './thumb2.jpg'
import thumb3 from './thumb3.jpg'

export { vip_room_preview, vip_room, thumb1, thumb2, thumb3, image1, image2, image3 }



// WEBPACK FOOTER //
// ./src/features/Hotel/components/VipRoom/images/index.js